<template>
  <div class="job-application-availability cell" v-if="require_availability">
    <div class="field">
      <label for="posting-availability">Availability <sup>*</sup></label>
      <div id="posting-availability" class="field__wrapper">
        Please specify days and times between 8:00AM - 5:00PM you are available.

        <div class="posting-availability-block" :key="index" v-for="(availability, index) in sortedAvailabilites">
          <div class="grid-x grid-margin-x">
            <div class="cell tablet-6">
              <input type="hidden" class="availability-days" :name="getDaysFieldName(index)" :value="availability.days.join(', ')">

              <multiselect
                v-model="availability.days"
                :options="availableDays"
                :multiple="true"
                selectLabel=""
                deselectLabel=""
                selectedLabel=""
                :searchable="false"
                placeholder="Select Day(s)"
                ref="multiselect"
                @select="handleSelect"
              />
            </div>

            <div class="cell tablet-6">
              <input type="text" v-model="availability.times" placeholder="Enter Start & End Time for selected day(s)" :name="getTimesFieldName(index)">

              <button type="button" class="remove-availability" @click="removeAvailability(index)" v-if="index !== 0">&times; Remove</button>
            </div>
          </div>
        </div>

        <button type="button" class="btn btn--small" @click="addAvailability" v-if="canAdd">Add Availability</button>
        <input type="hidden" name="HasAvailability" value="1">
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  name: 'JobApplicationAvailability',

  components: {
    Multiselect
  },

  data() {
    return {
      postingId: null,
      require_availability: null,
      require_languages: null,
      valid: false,
      selectableDays: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ],
      availabilities: [{
        days: [],
        times: ''
      }]
    }
  },

  computed: {
    availableDays: function () {
      const days = [...this.selectableDays]
      const selectedDays = this.availabilities.reduce((days, availability) => {
        return days.concat(availability.days)
      }, [])

      return days.filter(day => selectedDays.indexOf(day) === -1)
    },

    canAdd: function () {
      const hasEmptyDays = this.availabilities.filter(a => !a.days.length).length > 0

      return !hasEmptyDays && this.availableDays.length
    },

    sortedAvailabilites: function () {
      const availabilities = [...this.availabilities]
      const selectableDays = this.selectableDays

      availabilities.forEach(item => {
        item.days.sort((a, b) => selectableDays.indexOf(a) - selectableDays.indexOf(b))
      })

      return availabilities
    }
  },

  methods: {
    setPosting: function (data) {
      this.postingId = data.id
      this.require_availability = data.require_availability
      this.require_languages = data.require_languages
    },

    addAvailability: function () {
      this.availabilities.push({
        days: [],
        times: ''
      })
    },

    removeAvailability: function (index) {
      const availabilities = [...this.availabilities]
      availabilities.splice(index, 1)

      this.availabilities = availabilities
    },

    getDaysFieldName: function (index) {
      return `availability_days[${index}]`
    },

    getTimesFieldName: function (index) {
      return `availability_times[${index}]`
    },

    handleSelect: function () {
      document.querySelectorAll('.availability-days').forEach(el => el.classList.remove('has-field-error'))
    }
  }
}
</script>
